import { type ReactNode } from "react";
import { MarginLayout } from "~/components/layouts/MarginLayout";

type BannerProps = {
  title: string;
  children?: ReactNode;
};

const Banner: React.FC<BannerProps> = ({ title, children }) => {
  return (
    <div className="flex flex-shrink-0 items-center bg-sky-900">
      <MarginLayout verticalPadding="sm" className="-mt-1">
        <h1 className="heading-inherit-color text-white h1">{title}</h1>
        {children && <div className="mt-4 w-full">{children}</div>}
      </MarginLayout>
    </div>
  );
};

export { Banner };
